var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { Link } from '@nordlayer/rivendell-ui';
import styled from 'styled-components';
import nordLayerSvg from '../../../../assets/logo.svg';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  outline: none;\n\n  &[data-focus-visible] {\n    outline: 1px solid var(--riv-color-border-focus);\n    border-radius: var(--riv-border-radius-md);\n  }\n"])));
export var LogoLink = function LogoLink(_ref) {
    var _ref$dataTestid = _ref['data-testid'], dataTestId = _ref$dataTestid === void 0 ? 'logo-link' : _ref$dataTestid;
    return /*#__PURE__*/ _jsx(StyledLink, {
        href: "/",
        "data-testid": dataTestId,
        children: /*#__PURE__*/ _jsx("img", {
            src: nordLayerSvg,
            alt: "Nordlayer logo"
        })
    });
};
